// This sets up global listeners to handle chunk load failures (e.g., from React.lazy)
function setupChunkErrorHandler() {
  sessionStorage.removeItem('chunkErrorReloaded')

  // Handle synchronous chunk load errors (rare, older browsers)
  window.addEventListener('error', (e: any) => {
    const message = e?.message || ''
    const isChunkLoadError = message?.includes('Loading chunk') || e?.type === 'ChunkLoadError'

    if (isChunkLoadError) {
      handleChunkError('sync')
    }
  })

  // Handle async chunk load errors (most common case from dynamic import)
  window.addEventListener('unhandledrejection', (event: any) => {
    const message = event?.reason?.message || ''
    const isChunkLoadError =
      message?.includes('Loading chunk') ||
      message?.includes('ChunkLoadError') ||
      event?.reason?.name === 'ChunkLoadError'

    if (isChunkLoadError) {
      handleChunkError('async')
    }
  })

  function handleChunkError(type: 'sync' | 'async') {
    if (!sessionStorage.getItem('chunkErrorReloaded')) {
      console.warn(`🔁 ChunkLoadError (${type}) detected, reloading page...`)
      sessionStorage.setItem('chunkErrorReloaded', 'true')
      window.location.reload()
    } else {
      console.warn('🔁 ChunkLoadError happened again after reload — not retrying.')
    }
  }
}

export default setupChunkErrorHandler
